module.exports = __webpack_public_path__ + "img/habitation_button.72abe74c.png";